import { styled } from "@mui/system";
import ModalUnstyled from "@mui/base/ModalUnstyled";

export const h3Style = {
  fontFamily: "SofiaPro",
  fontWeight: "700",
  fontSize: "24px",
  color: "#161728",
  marginBottom: "6px",
};

export const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Backdrop = styled("div")`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`;

export const style = {
  bgcolor: "background.paper",
  p: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "white",
  borderRadius: "20px",
  width: "640px",
  maxWidth: "90vw",
  minHeight: "360px",
};
